import React, { forwardRef } from 'react';
import Size from '../private/enums/Size';
import TextInputBasic from './private/TextInputBasic';
import TextInputInnerLabel from './private/TextInputInnerLabel';
import TextInputPasswort from './private/TextInputPasswort';
const TextInput = forwardRef((props, ref) => {
    const { inputSize = Size.MEDIUM, type } = props;
    // render input with show/hide password
    if (type === 'password') {
        return React.createElement(TextInputPasswort, Object.assign({}, props, { ref: ref }));
    }
    if (inputSize === Size.XLARGE) {
        return React.createElement(TextInputInnerLabel, Object.assign({}, props, { ref: ref }));
    }
    // render rest sizes
    return React.createElement(TextInputBasic, Object.assign({}, props, { ref: ref }));
});
export default TextInput;
